import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import {
  DocumentUpdateMetadatiFormAbstractComponent
} from '../../../form/documento/document-update-metadati-form-abstract.component';
import { DocumentoAllegato } from '../../../models/documento-allegato';
import { DataInput } from '../../../models/dto/data-input';
import { UpdateMetadatiDocumentoRequest } from '../../../models/dto/update-metadati-documento-request';
import { SezioneDocumentazioneAllegata } from '../../../models/sezioni/sezione-documentazione-allegata';

declare var closeModal: any;

@Component({
  selector: '[doc_update_metadati_form]',
  templateUrl: '../../../form/documento/document-update-metadati-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class DocumentUpdateMetadatiFormComponent extends DocumentUpdateMetadatiFormAbstractComponent {

  @Output()
  onReturn: EventEmitter<string> = new EventEmitter<string>();

  fascicolo: any;
  tipoPratica: string;
  utenteProtocollatore:string = null;
  @Input() sezione: SezioneDocumentazioneAllegata;

  @Input() documento: DocumentoAllegato;

  @Input() separatorePathLogico: string;

  @Output()
  onReturnModal = new EventEmitter();


  constructor(
    operationService: OperationsService, 
    campiForm: FormBuilder, 
    helpers: HelpersService,
    fb: FormBuilder
  ) {
    super(operationService, campiForm, helpers, fb);
  }

  buildForm(documento: DocumentoAllegato, fascicolo, tipoPratica, esn?: string, isCensimentoDocumenti: boolean = false) {
    this.utenteProtocollatore = documento.utenteProtocollatore;
    this.tipoPratica = tipoPratica;
    this.fascicolo = fascicolo;
    this.isCensimentoDocumenti = isCensimentoDocumenti;
    this.getTipiProvenienza();
    this.getTipiDocumento();
    this.createForm(documento, esn);
  }

  saveOperation(documentoUpdated: DocumentoAllegato) {
    if ('primary' in documentoUpdated) {
      delete (documentoUpdated as any).primary;    
    }
    let request: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
    documentoUpdated.utenteProtocollatore = this.utenteProtocollatore;
    request.documento = documentoUpdated;
    request.dataInput = new DataInput(this.fascicolo.praticaBase.id, this.fascicolo.id, this.fascicolo.praticaBase.intestazione.campi.posizionePratica, this.fascicolo.posizione, this.tipoPratica);

    this.operationService.updateMetadatiDocumento(request).subscribe(response => this.docUpdated(response));
  }

  docUpdated(response) {
    if (response.returnCode === 'OK') {
      this.onReturnModal.emit(response);
    }
  }

  getSeparatorePathLogico() {
    return this.separatorePathLogico;
  }

}
